import styled from 'styled-components';

export const SCanvasWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 6px;
`;
